/**
 * 히어로 섹션 컴포넌트
 * 랜딩 페이지의 메인 히어로 섹션을 렌더링
 */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  text-align: center;\n  margin-bottom: 4rem;\n  padding: 0 1rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-size: 2.25rem;\n  font-weight: bold;\n  margin-bottom: 1.5rem;\n  color: #111827;\n  line-height: 1.2;\n  \n  @media (min-width: 768px) {\n    font-size: 3.75rem;\n  }\n  \n  .gradient-text {\n    background: linear-gradient(90deg, \n      var(--primary, #2563eb) 0%, \n      var(--secondary, #9333ea) 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  color: #4b5563;\n  max-width: 48rem;\n  margin-left: auto;\n  margin-right: auto;\n  line-height: 1.8;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  \n  @media (min-width: 640px) {\n    flex-direction: row;\n    justify-content: center;\n    gap: 1.5rem;\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
import { LANDING_PAGE_TEST_IDS } from '@edusense/shared-constants';
// 스타일 컴포넌트
var HeroContainer = styled.section(_templateObject());
var HeroTitle = styled.h1(_templateObject1());
var HeroDescription = styled.p(_templateObject2());
var ActionsContainer = styled.div(_templateObject3());
/**
 * 히어로 섹션 컴포넌트
 * 
 * @example
 * ```tsx
 * <HeroSection
 *   title="미래의 학습, "
 *   gradientText="EduSense"
 *   titleSuffix="와 함께"
 *   description="AI 기반의 코딩 보조, 맞춤형 튜터링으로 개발 역량을 확장하세요."
 *   actions={
 *     <Button color="primary" size="lg">
 *       시작하기
 *     </Button>
 *   }
 * />
 * ```
 */ export var HeroSection = function(param) {
    var title = param.title, titleSuffix = param.titleSuffix, description = param.description, gradientText = param.gradientText, actions = param.actions, customContent = param.customContent, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    return /*#__PURE__*/ React.createElement(HeroContainer, {
        className: className,
        "data-testid": LANDING_PAGE_TEST_IDS.HERO_SECTION
    }, /*#__PURE__*/ React.createElement(HeroTitle, {
        "data-testid": LANDING_PAGE_TEST_IDS.HERO_TITLE
    }, title, gradientText && /*#__PURE__*/ React.createElement("span", {
        className: "gradient-text"
    }, gradientText), titleSuffix), /*#__PURE__*/ React.createElement(HeroDescription, {
        "data-testid": LANDING_PAGE_TEST_IDS.HERO_DESCRIPTION
    }, description), customContent ? customContent : actions ? /*#__PURE__*/ React.createElement(ActionsContainer, null, actions) : null);
};
export default HeroSection;
